/**
 * Detects whether the current platform is macOS.
 *
 * Prefers the modern `userAgentData.platform` and falls back to the legacy
 * `navigator.platform`. Returns `false` in non-browser environments.
 */
export const isMacPlatform = (): boolean => {
  if (typeof navigator === 'undefined') {
    return false;
  }

  const platform = (navigator as any).userAgentData?.platform ?? navigator.platform ?? '';

  return /^mac/i.test(platform);
};
